import { IAssetBase, IAssetModel } from "@/apps/app.content";
import ContentLincolnCenterBase from "../../content.lincolncenter.base";
import { IContentItem } from "../../content.lincolncenter.config";
import {
  AbstractMesh,
  Engine,
  PBRMaterial,
  ShadowGenerator,
  StandardMaterial,
} from "babylonjs";

export interface IContentMilesModelProps {
  id: string;
  modelPath: string;
  config: IContentItem;
  // shadowGenerator: ShadowGenerator;
}

export class ContentMilesModel extends ContentLincolnCenterBase {
  public id: string;
  public modelPath: string;
  private config: IContentItem;
  private meshRoot?: AbstractMesh;
  private meshes: AbstractMesh[] = [];

  constructor(props: IContentMilesModelProps) {
    super();
    this.id = props.id;
    this.modelPath = props.modelPath;
    this.config = props.config;

    (window as any).resetToCam = () => {
      debugger;
      this.meshRoot!.position.copyFrom(this.camera!.position);
      // console
    };
  }

  public override get assets(): IAssetBase[] {
    return [
      {
        id: this.id,
        type: "model",
        path: this.modelPath,
      },
    ];
  }

  public hide() {
    if (this.meshRoot) {
      this.meshRoot.setEnabled(false);
      this.meshes.forEach((mesh) => {
        mesh.setEnabled(false);
      });
    }
  }

  public show() {
    if (this.meshRoot) {
      this.meshRoot.setEnabled(true);
      this.meshes.forEach((mesh) => {
        mesh.setEnabled(true);
      });
    }
  }

  public loadAssetComplete(_asset: IAssetBase): void {
    if (_asset.id === this.id) {
      const model = _asset as IAssetModel;
      //this.scene!.useOrderIndependentTransparency = true;

      if (model.meshRoot) {
        console.log("model.meshRoot", model.meshRoot);
        model.meshRoot.setEnabled(true);
        const meshRoot = model.meshRoot;
        this.meshRoot = meshRoot;
      }

      // Set the alpha cutoff threshold

      if (this.config && model.meshRoot) {
        model.meshRoot?.position.copyFrom(this.config.target);
        model.meshRoot?.rotation.copyFrom(this.config.rotation);
        model.meshRoot?.scaling.copyFrom(this.config.scale);
        // this.shadowGenerator.addShadowCaster(model.meshRoot, true);
      }

      this.meshes = model.meshes ?? [];

      model!.meshes!.forEach((mesh) => {
       
        if (mesh.material) {
          mesh.receiveShadows = true;
          // this.shadowGenerator.addShadowCaster(mesh, true);

          const oldMaterial = mesh.material as PBRMaterial;

          const constructedStandardMaterial = new StandardMaterial(
            "constructedStandardMaterial",
            this.scene!
          );
          constructedStandardMaterial.diffuseColor = oldMaterial.albedoColor;
          constructedStandardMaterial.diffuseTexture =
            oldMaterial.albedoTexture;

          const material = mesh.material as PBRMaterial;
          material.backFaceCulling = false;
          material.needDepthPrePass = true;
          material.alphaMode = Engine.ALPHA_COMBINE;
          if (material.albedoTexture) {
            material.albedoTexture.hasAlpha = true;
          }
          // material.emissiveTexture = material.albedoTexture;
          material.transparencyMode = PBRMaterial.PBRMATERIAL_ALPHATESTANDBLEND;
          material.alphaCutOff = 0.2;
          
          //mesh.material = shaderMaterial;
          mesh.material = material;

        }
      });

      
    }
  }
}
